document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".brand-comparison__percentage-inner");

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const percentage = el.getAttribute("data-percentage");

        el.style.width = percentage + "%";

        observer.unobserve(el);
      }
    });
  }, {
    threshold: 0.3
  });

  items.forEach(item => observer.observe(item));
});
